import { CodedProperty, NamedProperty } from "sprint-common-web";

interface ContentVersionAttributes {
    type: NamedProperty;
    distributor?: NamedProperty;
    airlines: CodedProperty[];
}

export const renderContentVersionText = ({ type, distributor, airlines }: ContentVersionAttributes): string => {
    const distributorName = distributor?.name;
    const typeName = type.name;
    const joinedAirlines = airlines?.map((branding) => branding.code).join(", ");

    return [distributorName, typeName, joinedAirlines].filter((text) => text !== undefined && text !== "").join(" - ");
};

interface BrandedContentVersionAttributes {
    type: NamedProperty;
    distributor: NamedProperty;
    brandings?: CodedProperty[];
}

export const renderBrandedContentVersionText = ({
    type,
    distributor,
    brandings
}: BrandedContentVersionAttributes): string => {
    return renderContentVersionText({ type, distributor, airlines: brandings ?? [] });
};
